import { defaultSwiperOptions } from '../SwiperInit';
import Swiper, {
    Navigation,
    Pagination,
    Mousewheel,
    A11y,
    EffectFade,
    Keyboard,
    Autoplay,
    Lazy,
    Scrollbar,
} from 'swiper';

Swiper.use([Navigation, Pagination, Mousewheel, A11y, EffectFade, Keyboard, Autoplay, Lazy, Scrollbar]);

const swiperInstances = [];

function initOptionalDesktopSlider() {
    const onDesktop = window.matchMedia('(min-width: 768px)').matches;

    if (onDesktop) {
        // create
        [...document.querySelectorAll('.js-slider-on-desktop')].forEach((element) => {
            const sliderWrapper = element.querySelector('.neos-contentcollection');
            if (!sliderWrapper) {
                return;
            }

            sliderWrapper.classList.add('swiper-wrapper');
            sliderWrapper.childNodes.forEach((childNode) => childNode.classList.add('swiper-slide'));

            let pagination = element.querySelector('.swiper-pagination');

            if (pagination === null) {
                pagination = document.createElement('div');
                pagination.classList.add('swiper-pagination');

                element.appendChild(pagination);
            }

            const swiper = new Swiper(element, {
                ...defaultSwiperOptions,
                slidesPerView: 3,
                spaceBetween: 20,
                pagination: {
                    el: pagination,
                    clickable: true,
                },
                navigation: false,
                // prevent first slide from being cut off on smaller screens
                //centeredSlides: true,

                breakpoints: {
                    1920: {
                        centeredSlides: false,
                    },
                },
            });

            swiperInstances.push(swiper);
        });
    } else {
        // destroy
        swiperInstances.forEach((swiper) => swiper.destroy());
        [...document.querySelectorAll('.js-slider-on-desktop:not(.js-slider-on-mobile)')].forEach((element) => {
            const sliderWrapper = element.querySelector('.neos-contentcollection');
            if (!sliderWrapper) {
                return;
            }

            const pagination = element.querySelector('.swiper-pagination');
            if (pagination) {
                pagination.remove();
            }

            sliderWrapper.classList.remove('swiper-wrapper');
            sliderWrapper.childNodes.forEach((childNode) => childNode.classList.remove('swiper-slide'));
        });
    }
}

initOptionalDesktopSlider();

let delayed;
window.addEventListener('resize', () => {
    if (delayed) {
        clearTimeout(delayed);
    }
    delayed = setTimeout(() => {
        initOptionalDesktopSlider();
    }, 500);
});
